const CockFightingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      version="1"
      viewBox="0 0 768 768"
      style={{
        fill: "white",
        height: "28px",
        width: "28px",
      }}
    >
      <defs>
        <clipPath id="dda30a9625">
          <path d="M216 311h336v436.934H216zm0 0"></path>
        </clipPath>
        <clipPath id="6645aa60c7">
          <path d="M363 20.434h42V62h-42zm0 0"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#dda30a9625)">
        <path
          fill="#F5F5F9"
          d="M551.102 449.84c.87-24.242-8.707-47.668-25.512-65.14-42.172-43.829-161.235-141.626-278.227 1.335-6.793 8.305-5.347 20.64 3.223 27.102 3.5 2.652 7.254 5.781 10.945 9.394 2.856 2.797 6.477 4.73 10.438 5.274 31.707 4.41 58.734-28.075 67.691-40.309 4.04 7.043 11.98 11.563 20.887 10.527 9.707-1.132 17.504-9.054 18.504-18.777.625-6.035-1.297-11.617-4.817-15.82 27.633-4.004 56.48 14.902 56.48 14.902-39.53 70.742-139.28 60.524-157.612 57.988 12.66 18.899 17.867 45.247-7.11 77.66 0 0-85.25 123.02-31.558 234.133 0 0 17.086-118.82 120.52-159.129-.7-31.503 16.812-74.96 71.89-134.218l3.87-4.168 3.876 4.168c29.258 31.468 47.902 58.476 58.86 81.613 30.878-20.293 56.28-48.469 57.652-86.535"
        ></path>
      </g>
      <g>
        <path
          fill="#F5F5F9"
          d="M271.027 480.512c.118-.864.215-1.715.297-2.57 4.02-43.676-52.336-63.844-77.922-28.22-16.441 22.883-11.953 43.696-11.953 43.696 18.953-23.227 44.793-30.324 44.793-30.324-15.879 12.906-27.262 20.004-27.262 20.004 30.81 22.582 72.047-2.586 72.047-2.586M430.715 466.172c-65.676 72.117-82.094 128.926-47.45 164.469 12.489 12.816 29.34 19.87 47.45 19.87 18.113 0 34.965-7.054 47.453-19.87 34.644-35.543 18.227-92.352-47.453-164.47M256.488 303.586l-114.336-41.668 84.598 105.828s68.074-77.492 157.168-78.82c89.098 1.328 157.172 78.82 157.172 78.82l84.597-105.828-114.335 41.668V154.77l-85.262 64.816-42.172-145.512-42.172 145.512-85.258-64.816v148.816M646.176 268.531c11.308 0 20.484-9.176 20.484-20.5 0-11.328-9.176-20.504-20.484-20.504-11.32 0-20.489 9.176-20.489 20.504 0 11.324 9.168 20.5 20.489 20.5M525.89 147.492c11.31 0 20.485-9.176 20.485-20.504 0-11.328-9.176-20.504-20.484-20.504-11.32 0-20.489 9.176-20.489 20.504 0 11.328 9.168 20.504 20.489 20.504"
        ></path>
      </g>
      <g clipPath="url(#6645aa60c7)">
        <path
          fill="#F5F5F9"
          d="M383.918 61.504c11.32 0 20.488-9.18 20.488-20.504 0-11.32-9.168-20.504-20.488-20.504-11.316 0-20.484 9.184-20.484 20.504 0 11.324 9.168 20.504 20.484 20.504"
        ></path>
      </g>
      <g>
        <path
          fill="#F5F5F9"
          d="M240.5 147.492c11.316 0 20.488-9.176 20.488-20.504 0-11.328-9.172-20.504-20.488-20.504-11.309 0-20.488 9.176-20.488 20.504 0 11.328 9.18 20.504 20.488 20.504M121.664 268.531c11.32 0 20.488-9.176 20.488-20.5 0-11.328-9.168-20.504-20.488-20.504-11.309 0-20.484 9.176-20.484 20.504 0 11.324 9.175 20.5 20.484 20.5"
        ></path>
      </g>
    </svg>
  );
};

export default CockFightingIcon;
